import EventCategory from "../../lib/models/EventCategory";

export default {
    name: 'EventMixin',

    methods: {
        fetchCategories() {
            EventCategory.api().fetchCategories();
        },
    },
};
